import { useState } from "react";
import { api } from "../api/client";
import { useI18n } from "../i18n/I18nProvider";
import { AlertBanner, Button, Card, CodeBlock, FieldShell, Input, typographyClass } from "../ui-kit";

export function WorkspacesPage() {
  const { t } = useI18n();
  const [workspaceId, setWorkspaceId] = useState("");
  const [pipelineId, setPipelineId] = useState("");
  const [result, setResult] = useState<unknown>(null);
  const [error, setError] = useState<string | null>(null);

  const call = async (action: () => Promise<unknown>) => {
    setError(null);
    try {
      setResult(await action());
    } catch (cause) {
      setResult(null);
      setError(cause instanceof Error ? cause.message : String(cause));
    }
  };

  return (
    <Card>
      <h1 className={typographyClass("header-24-semibold")}>{t("workspaces.title")}</h1>
      <p className={typographyClass("text-14-medium")} style={{ color: "var(--color-text-secondary-v2)" }}>
        {t("workspaces.subtitle")}
      </p>

      <FieldShell label="workspace_id" htmlFor="workspace-id">
        <Input id="workspace-id" inputMode="numeric" value={workspaceId} onChange={(event) => setWorkspaceId(event.target.value)} />
      </FieldShell>

      <FieldShell label={t("workspaces.pipelineId")} htmlFor="pipeline-id">
        <Input id="pipeline-id" inputMode="numeric" value={pipelineId} onChange={(event) => setPipelineId(event.target.value)} />
      </FieldShell>

      <div style={{ display: "flex", gap: "var(--spacing-2-5)", flexWrap: "wrap" }}>
        <Button onClick={() => call(() => api.workspaces())}>{t("workspaces.load")}</Button>
        <Button
          variant="secondary"
          disabled={!workspaceId}
          onClick={() => call(() => api.runWorkspace(Number(workspaceId), null))}
        >
          {t("workspaces.run")}
        </Button>
        <Button
          variant="tertiary"
          disabled={!pipelineId}
          onClick={() => call(() => api.pipeline(Number(pipelineId)))}
        >
          {t("workspaces.status")}
        </Button>
      </div>

      {error && <AlertBanner tone="error" title={t("status.error")}>{error}</AlertBanner>}
      {result != null && <CodeBlock code={JSON.stringify(result, null, 2)} copyLabel={t("action.copy")} />}
    </Card>
  );
}
